module.exports = __webpack_public_path__ + "static/media/사.e9970921.jpg";